import React, { useState } from 'react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardSidebar } from '../components/dashboard/DashboardSidebar';
import { UserIcon, BuildingIcon, MailIcon, PhoneIcon, LockIcon, BellIcon, GlobeIcon, SaveIcon, CheckIcon, CameraIcon, ShieldIcon, XIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ProfileDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('personal');
  const [isEditing, setIsEditing] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  // Mock user data
  const [userData, setUserData] = useState({
    name: 'FATHALLAH Mehdi',
    firstName: 'Mehdi',
    lastName: 'FATHALLAH',
    company: 'Tunipages',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'mehdi.fathallah@tunipages.com',
    phone: '+33 7 53 29 34 19',
    jobTitle: 'Directeur Commercial',
    country: 'Tunisie',
    city: 'Tunis',
    language: 'Français',
    companySize: '11-50 employés',
    companySector: 'Services & Conseil',
    notificationPreferences: {
      email: true,
      app: true,
      tenders: true,
      alerts: true,
      marketing: false
    }
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setUserData({
      ...userData,
      [name]: value
    });
  };
  const toggleNotificationPreference = (key: string) => {
    setUserData({
      ...userData,
      notificationPreferences: {
        ...userData.notificationPreferences,
        [key]: !userData.notificationPreferences[key as keyof typeof userData.notificationPreferences]
      }
    });
  };
  const handleSave = () => {
    // Here you would typically send the updated data to your backend
    console.log('Saving user data:', userData);
    setIsEditing(false);
    setSuccessMessage('Vos informations ont été mises à jour avec succès!');
    // Clear success message after a delay
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };
  const handleCancel = () => {
    // Reset any changes
    setUserData({
      name: 'FATHALLAH Mehdi',
      firstName: 'Mehdi',
      lastName: 'FATHALLAH',
      company: 'Tunipages',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      email: 'mehdi.fathallah@tunipages.com',
      phone: '+216 71 234 567',
      jobTitle: 'Directeur Commercial',
      country: 'Tunisie',
      city: 'Tunis',
      language: 'Français',
      companySize: '11-50 employés',
      companySector: 'Services & Conseil',
      notificationPreferences: {
        email: true,
        app: true,
        tenders: true,
        alerts: true,
        marketing: false
      }
    });
    setIsEditing(false);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-3271">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-3272" />}
      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-3273" />
      {/* Main content */}
      <div className="md:pl-64" data-id="element-3274">
        {/* Header */}
        <DashboardHeader user={userData} onMenuClick={() => setSidebarOpen(true)} data-id="element-3275" />
        {/* Main content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-3276">
          {/* Page header */}
          <div className="mb-6" data-id="element-3277">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-3278">
              <div className="flex items-center mb-4 md:mb-0" data-id="element-3279">
                <UserIcon size={24} className="text-blue-600 mr-3" data-id="element-3280" />
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-3281">Mon Profil</h1>
              </div>
              {!isEditing ? <Button variant="primary" onClick={() => setIsEditing(true)} className="flex items-center justify-center shadow-lg shadow-yellow-500/20" data-id="element-3282">
                  Modifier mon profil
                </Button> : <div className="flex space-x-3" data-id="element-3283">
                  <Button variant="outline" onClick={handleCancel} data-id="element-3284">
                    Annuler
                  </Button>
                  <Button variant="primary" onClick={handleSave} className="flex items-center justify-center shadow-lg shadow-yellow-500/20" data-id="element-3285">
                    <SaveIcon size={16} className="mr-2" data-id="element-3286" />
                    Enregistrer
                  </Button>
                </div>}
            </div>
            <p className="mt-2 text-gray-600" data-id="element-3287">
              Gérez vos informations personnelles et vos préférences
            </p>
          </div>
          {/* Success message */}
          {successMessage && <div className="mb-6 bg-green-100 border border-green-200 text-green-800 rounded-lg p-4 flex items-start" data-id="element-3288">
              <CheckIcon size={20} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3289" />
              <div data-id="element-3290">
                <p className="font-medium" data-id="element-3291">{successMessage}</p>
              </div>
              <button onClick={() => setSuccessMessage('')} className="ml-auto text-green-500 hover:text-green-700" data-id="element-3292">
                <XIcon size={16} data-id="element-3293" />
              </button>
            </div>}
          <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100" data-id="element-3294">
            {/* Profile header with avatar */}
            <div className="bg-blue-900 text-white p-8 relative" data-id="element-3295">
              <div className="absolute inset-0 opacity-10" data-id="element-3296">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-3297">
                  <defs data-id="element-3298">
                    <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-3299">
                      <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" data-id="element-3300" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#smallGrid)" data-id="element-3301" />
                </svg>
              </div>
              <div className="relative z-10 flex flex-col md:flex-row items-center" data-id="element-3302">
                <div className="relative mb-4 md:mb-0 md:mr-6" data-id="element-3303">
                  <div className="w-24 h-24 rounded-full overflow-hidden bg-blue-800 border-4 border-blue-700 shadow-lg" data-id="element-3304">
                    <img src={userData.avatar} alt={userData.name} className="w-full h-full object-cover" data-id="element-3305" />
                  </div>
                  {isEditing && <div className="absolute bottom-0 right-0 bg-yellow-500 text-blue-900 rounded-full p-1.5 cursor-pointer shadow-md" data-id="element-3306">
                      <CameraIcon size={16} data-id="element-3307" />
                    </div>}
                </div>
                <div data-id="element-3308">
                  <h2 className="text-2xl font-bold" data-id="element-3309">{userData.name}</h2>
                  <div className="flex flex-col sm:flex-row sm:items-center text-blue-100 mt-1 space-y-1 sm:space-y-0 sm:space-x-4" data-id="element-3310">
                    <div className="flex items-center" data-id="element-3311">
                      <BuildingIcon size={14} className="mr-1.5" data-id="element-3312" />
                      <span data-id="element-3313">{userData.company}</span>
                    </div>
                    <div className="flex items-center" data-id="element-3314">
                      <MailIcon size={14} className="mr-1.5" data-id="element-3315" />
                      <span data-id="element-3316">{userData.email}</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Decorative elements */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-blue-800 rounded-full opacity-50 transform translate-x-1/3 -translate-y-1/3" data-id="element-3317"></div>
              <div className="absolute bottom-0 left-0 w-20 h-20 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/2 translate-y-1/2" data-id="element-3318"></div>
            </div>
            {/* Tabs navigation */}
            <div className="border-b border-gray-200" data-id="element-3319">
              <nav className="flex overflow-x-auto" data-id="element-3320">
                <button onClick={() => setActiveTab('personal')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'personal' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3321">
                  <UserIcon size={16} className="inline-block mr-2" data-id="element-3322" />
                  Informations personnelles
                </button>
                <button onClick={() => setActiveTab('company')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'company' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3323">
                  <BuildingIcon size={16} className="inline-block mr-2" data-id="element-3324" />
                  Informations entreprise
                </button>
                <button onClick={() => setActiveTab('security')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'security' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3325">
                  <LockIcon size={16} className="inline-block mr-2" data-id="element-3326" />
                  Sécurité
                </button>
                <button onClick={() => setActiveTab('notifications')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'notifications' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3327">
                  <BellIcon size={16} className="inline-block mr-2" data-id="element-3328" />
                  Notifications
                </button>
              </nav>
            </div>
            {/* Tab content */}
            <div className="p-6" data-id="element-3329">
              {/* Personal information tab */}
              {activeTab === 'personal' && <div className="space-y-6" data-id="element-3330">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3331">
                    Informations personnelles
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3332">
                    <div data-id="element-3333">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3334">
                        Prénom
                      </label>
                      {isEditing ? <input type="text" id="firstName" name="firstName" value={userData.firstName} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3335" /> : <p className="text-gray-900 py-2" data-id="element-3336">
                          {userData.firstName}
                        </p>}
                    </div>
                    <div data-id="element-3337">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3338">
                        Nom
                      </label>
                      {isEditing ? <input type="text" id="lastName" name="lastName" value={userData.lastName} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3339" /> : <p className="text-gray-900 py-2" data-id="element-3340">
                          {userData.lastName}
                        </p>}
                    </div>
                    <div data-id="element-3341">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3342">
                        Email
                      </label>
                      {isEditing ? <input type="email" id="email" name="email" value={userData.email} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3343" /> : <p className="text-gray-900 py-2" data-id="element-3344">{userData.email}</p>}
                    </div>
                    <div data-id="element-3345">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3346">
                        Téléphone
                      </label>
                      {isEditing ? <input type="tel" id="phone" name="phone" value={userData.phone} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3347" /> : <p className="text-gray-900 py-2" data-id="element-3348">{userData.phone}</p>}
                    </div>
                    <div data-id="element-3349">
                      <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3350">
                        Fonction
                      </label>
                      {isEditing ? <input type="text" id="jobTitle" name="jobTitle" value={userData.jobTitle} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3351" /> : <p className="text-gray-900 py-2" data-id="element-3352">
                          {userData.jobTitle}
                        </p>}
                    </div>
                    <div data-id="element-3353">
                      <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3354">
                        Langue préférée
                      </label>
                      {isEditing ? <select id="language" name="language" value={userData.language} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3355">
                          <option value="Français" data-id="element-3356">Français</option>
                          <option value="English" data-id="element-3357">English</option>
                          <option value="العربية" data-id="element-3358">العربية</option>
                        </select> : <p className="text-gray-900 py-2" data-id="element-3359">
                          {userData.language}
                        </p>}
                    </div>
                  </div>
                </div>}
              {/* Company information tab */}
              {activeTab === 'company' && <div className="space-y-6" data-id="element-3360">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3361">
                    Informations entreprise
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3362">
                    <div data-id="element-3363">
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3364">
                        Nom de l'entreprise
                      </label>
                      {isEditing ? <input type="text" id="company" name="company" value={userData.company} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3365" /> : <p className="text-gray-900 py-2" data-id="element-3366">{userData.company}</p>}
                    </div>
                    <div data-id="element-3367">
                      <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3368">
                        Taille de l'entreprise
                      </label>
                      {isEditing ? <select id="companySize" name="companySize" value={userData.companySize} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3369">
                          <option value="1-10 employés" data-id="element-3370">1-10 employés</option>
                          <option value="11-50 employés" data-id="element-3371">11-50 employés</option>
                          <option value="51-200 employés" data-id="element-3372">
                            51-200 employés
                          </option>
                          <option value="201-500 employés" data-id="element-3373">
                            201-500 employés
                          </option>
                          <option value="Plus de 500 employés" data-id="element-3374">
                            Plus de 500 employés
                          </option>
                        </select> : <p className="text-gray-900 py-2" data-id="element-3375">
                          {userData.companySize}
                        </p>}
                    </div>
                    <div data-id="element-3376">
                      <label htmlFor="companySector" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3377">
                        Secteur d'activité
                      </label>
                      {isEditing ? <select id="companySector" name="companySector" value={userData.companySector} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3378">
                          <option value="BTP & Construction" data-id="element-3379">
                            BTP & Construction
                          </option>
                          <option value="Énergie & Utilities" data-id="element-3380">
                            Énergie & Utilities
                          </option>
                          <option value="Santé & Pharmaceutique" data-id="element-3381">
                            Santé & Pharmaceutique
                          </option>
                          <option value="Agriculture & Agroalimentaire" data-id="element-3382">
                            Agriculture & Agroalimentaire
                          </option>
                          <option value="Technologies & Télécoms" data-id="element-3383">
                            Technologies & Télécoms
                          </option>
                          <option value="Services & Conseil" data-id="element-3384">
                            Services & Conseil
                          </option>
                          <option value="Transport & Logistique" data-id="element-3385">
                            Transport & Logistique
                          </option>
                          <option value="Autre" data-id="element-3386">Autre</option>
                        </select> : <p className="text-gray-900 py-2" data-id="element-3387">
                          {userData.companySector}
                        </p>}
                    </div>
                    <div data-id="element-3388">
                      <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3389">
                        Pays
                      </label>
                      {isEditing ? <select id="country" name="country" value={userData.country} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3390">
                          <option value="Tunisie" data-id="element-3391">Tunisie</option>
                          <option value="Algérie" data-id="element-3392">Algérie</option>
                          <option value="Maroc" data-id="element-3393">Maroc</option>
                          <option value="Sénégal" data-id="element-3394">Sénégal</option>
                          <option value="Côte d'Ivoire" data-id="element-3395">Côte d'Ivoire</option>
                          <option value="France" data-id="element-3396">France</option>
                        </select> : <p className="text-gray-900 py-2" data-id="element-3397">{userData.country}</p>}
                    </div>
                    <div data-id="element-3398">
                      <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3399">
                        Ville
                      </label>
                      {isEditing ? <input type="text" id="city" name="city" value={userData.city} onChange={handleInputChange} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3400" /> : <p className="text-gray-900 py-2" data-id="element-3401">{userData.city}</p>}
                    </div>
                  </div>
                </div>}
              {/* Security tab */}
              {activeTab === 'security' && <div className="space-y-6" data-id="element-3402">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3403">
                    Sécurité et confidentialité
                  </h3>
                  <div className="space-y-6 max-w-lg" data-id="element-3404">
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-3405">
                      <div className="flex items-start" data-id="element-3406">
                        <ShieldIcon size={20} className="text-blue-600 mr-3 mt-0.5" data-id="element-3407" />
                        <div data-id="element-3408">
                          <h4 className="font-medium text-blue-900" data-id="element-3409">
                            Sécurité du compte
                          </h4>
                          <p className="mt-1 text-sm text-blue-700" data-id="element-3410">
                            Pour renforcer la sécurité de votre compte, nous
                            vous recommandons de changer votre mot de passe
                            régulièrement et d'utiliser un mot de passe fort.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-3411">
                      <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3412">
                        Changer votre mot de passe
                      </h4>
                      <div className="space-y-4" data-id="element-3413">
                        <div data-id="element-3414">
                          <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3415">
                            Mot de passe actuel
                          </label>
                          <input type="password" id="currentPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3416" />
                        </div>
                        <div data-id="element-3417">
                          <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3418">
                            Nouveau mot de passe
                          </label>
                          <input type="password" id="newPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3419" />
                          <p className="mt-1 text-xs text-gray-500" data-id="element-3420">
                            Le mot de passe doit contenir au moins 8 caractères,
                            dont une lettre majuscule, une lettre minuscule et
                            un chiffre.
                          </p>
                        </div>
                        <div data-id="element-3421">
                          <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3422">
                            Confirmer le nouveau mot de passe
                          </label>
                          <input type="password" id="confirmPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3423" />
                        </div>
                        <div data-id="element-3424">
                          <Button variant="primary" className="shadow-md shadow-yellow-500/20 mt-2" data-id="element-3425">
                            Mettre à jour le mot de passe
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="pt-4 border-t border-gray-200" data-id="element-3426">
                      <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3427">
                        Sessions actives
                      </h4>
                      <div className="space-y-3" data-id="element-3428">
                        <div className="bg-white p-3 border border-gray-200 rounded-md" data-id="element-3429">
                          <div className="flex items-center justify-between" data-id="element-3430">
                            <div data-id="element-3431">
                              <div className="font-medium" data-id="element-3432">
                                Chrome sur Windows
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-3433">
                                Tunis, Tunisie · Actif maintenant
                              </div>
                            </div>
                            <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full" data-id="element-3434">
                              Session actuelle
                            </div>
                          </div>
                        </div>
                        <div className="bg-white p-3 border border-gray-200 rounded-md" data-id="element-3435">
                          <div className="flex items-center justify-between" data-id="element-3436">
                            <div data-id="element-3437">
                              <div className="font-medium" data-id="element-3438">
                                Safari sur iPhone
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-3439">
                                Tunis, Tunisie · Dernière activité il y a 2
                                jours
                              </div>
                            </div>
                            <Button variant="outline" size="sm" className="text-xs" data-id="element-3440">
                              Déconnecter
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Notifications tab */}
              {activeTab === 'notifications' && <div className="space-y-6" data-id="element-3441">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3442">
                    Préférences de notification
                  </h3>
                  <div className="space-y-6" data-id="element-3443">
                    <div data-id="element-3444">
                      <h4 className="text-base font-medium text-gray-900 mb-3" data-id="element-3445">
                        Canaux de notification
                      </h4>
                      <div className="space-y-3" data-id="element-3446">
                        <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3447">
                          <div className="flex items-center" data-id="element-3448">
                            <MailIcon size={18} className="text-gray-500 mr-3" data-id="element-3449" />
                            <span className="text-gray-900" data-id="element-3450">Email</span>
                          </div>
                          <div className="relative inline-block w-10 align-middle select-none" data-id="element-3451">
                            <input type="checkbox" name="email-toggle" id="email-toggle" checked={userData.notificationPreferences.email} onChange={() => toggleNotificationPreference('email')} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3452" />
                            <label htmlFor="email-toggle" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${userData.notificationPreferences.email ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3453">
                              <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${userData.notificationPreferences.email ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3454"></span>
                            </label>
                          </div>
                        </div>
                        <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3455">
                          <div className="flex items-center" data-id="element-3456">
                            <BellIcon size={18} className="text-gray-500 mr-3" data-id="element-3457" />
                            <span className="text-gray-900" data-id="element-3458">
                              Notifications dans l'application
                            </span>
                          </div>
                          <div className="relative inline-block w-10 align-middle select-none" data-id="element-3459">
                            <input type="checkbox" name="app-toggle" id="app-toggle" checked={userData.notificationPreferences.app} onChange={() => toggleNotificationPreference('app')} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3460" />
                            <label htmlFor="app-toggle" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${userData.notificationPreferences.app ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3461">
                              <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${userData.notificationPreferences.app ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3462"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-3463">
                      <h4 className="text-base font-medium text-gray-900 mb-3" data-id="element-3464">
                        Types de notifications
                      </h4>
                      <div className="space-y-3" data-id="element-3465">
                        <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3466">
                          <div data-id="element-3467">
                            <span className="text-gray-900" data-id="element-3468">
                              Nouveaux appels d'offres
                            </span>
                            <p className="text-sm text-gray-500" data-id="element-3469">
                              Recevez des notifications pour les nouveaux appels
                              d'offres correspondant à vos critères.
                            </p>
                          </div>
                          <div className="relative inline-block w-10 align-middle select-none" data-id="element-3470">
                            <input type="checkbox" name="tenders-toggle" id="tenders-toggle" checked={userData.notificationPreferences.tenders} onChange={() => toggleNotificationPreference('tenders')} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3471" />
                            <label htmlFor="tenders-toggle" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${userData.notificationPreferences.tenders ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3472">
                              <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${userData.notificationPreferences.tenders ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3473"></span>
                            </label>
                          </div>
                        </div>
                        <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3474">
                          <div data-id="element-3475">
                            <span className="text-gray-900" data-id="element-3476">Alertes</span>
                            <p className="text-sm text-gray-500" data-id="element-3477">
                              Recevez des notifications pour vos alertes
                              personnalisées.
                            </p>
                          </div>
                          <div className="relative inline-block w-10 align-middle select-none" data-id="element-3478">
                            <input type="checkbox" name="alerts-toggle" id="alerts-toggle" checked={userData.notificationPreferences.alerts} onChange={() => toggleNotificationPreference('alerts')} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3479" />
                            <label htmlFor="alerts-toggle" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${userData.notificationPreferences.alerts ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3480">
                              <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${userData.notificationPreferences.alerts ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3481"></span>
                            </label>
                          </div>
                        </div>
                        <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3482">
                          <div data-id="element-3483">
                            <span className="text-gray-900" data-id="element-3484">
                              Marketing et actualités
                            </span>
                            <p className="text-sm text-gray-500" data-id="element-3485">
                              Recevez des informations sur nos nouvelles
                              fonctionnalités et offres promotionnelles.
                            </p>
                          </div>
                          <div className="relative inline-block w-10 align-middle select-none" data-id="element-3486">
                            <input type="checkbox" name="marketing-toggle" id="marketing-toggle" checked={userData.notificationPreferences.marketing} onChange={() => toggleNotificationPreference('marketing')} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3487" />
                            <label htmlFor="marketing-toggle" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${userData.notificationPreferences.marketing ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3488">
                              <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${userData.notificationPreferences.marketing ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3489"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pt-4" data-id="element-3490">
                      <Button variant="primary" onClick={handleSave} className="shadow-md shadow-yellow-500/20" data-id="element-3491">
                        Enregistrer les préférences
                      </Button>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
          {/* Account deletion */}
          <div className="mt-6 bg-white rounded-lg shadow-md overflow-hidden border border-gray-100" data-id="element-3492">
            <div className="p-6 border-b border-gray-200" data-id="element-3493">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-3494">
                Suppression du compte
              </h3>
            </div>
            <div className="p-6" data-id="element-3495">
              <div className="flex items-start" data-id="element-3496">
                <div className="flex-shrink-0" data-id="element-3497">
                  <div className="flex items-center justify-center h-12 w-12 rounded-full bg-red-100 text-red-600" data-id="element-3498">
                    <XIcon size={24} data-id="element-3499" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-3500">
                  <h4 className="text-lg font-medium text-gray-900" data-id="element-3501">
                    Supprimer définitivement votre compte
                  </h4>
                  <p className="mt-1 text-gray-600" data-id="element-3502">
                    Une fois que vous supprimez votre compte, vous perdrez
                    l'accès à tous vos appels d'offres sauvegardés, alertes et
                    historique. Cette action est irréversible.
                  </p>
                  <div className="mt-4" data-id="element-3503">
                    <Button variant="outline" className="text-red-600 border-red-600 hover:bg-red-50" data-id="element-3504">
                      Supprimer mon compte
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
}